import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Input } from '@hotjar/webapp/components/Input';
import { Select } from '@hotjar/webapp/components/Select';
import { tokens } from '@hotjar/hotsauce';

export const Label = styled.label`
  font-weight: 600;
  font-size: 12px;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: ${tokens.color.text_default};
  display: block;
  margin: 0;
`;

export const Description = styled.p`
  font-size: 12px;
  font-weight: normal;
  line-height: 17px;
  letter-spacing: 0.1px;
  text-transform: initial;
  color: ${tokens.color.text_light};
  margin: 0;
`;

export const StyledInput = styled(Input)`
  font-weight: normal;
  text-transform: none;
`;

export const StyledSelect = styled(Select)`
  font-weight: normal;
  text-transform: none;
`;

export const Section = styled.div``;

export const Paragraph = styled.p`
  font-size: 14px;
  color: ${tokens.color.text_default};
  line-height: 21px;
  font-weight: 400;
  letter-spacing: 0.1px;
`;

const LinkStyles = css`
  cursor: pointer;
  color: inherit;
  text-decoration: underline;
  &:hover,
  &:focus {
    color: inherit;
  }
`;

export const SpanLink = styled.span`
  ${LinkStyles}
`;

export const Link = styled.a`
  ${LinkStyles}
`;

export const Separator = styled.hr`
  margin: ${tokens.spacer.x3} 0;
  height: 0;
  width: 100%;
  border: 0;
  border-bottom: 1px solid ${tokens.color.ui_border_light};
`;
